import React from 'react';

function Skills() {
  return (
    // <div className="containers py-12">
      <div className="mt-6 lg:mt-24 mb-2 lg:mb-8 py-0 lg:py-7 w-full lg:max-w-6xl px-2 lg:px-44 mx-auto ml-2 lg:ml-2 bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-lg shadow-md p-1 lg:p-1">
      <div className="text-center mb-12">
        <h1 className="text-3xl font-bold">
          <span>MY SKILLS</span>
        </h1>
      </div>

      <div className="text-black ml-0 lg:ml-3 ">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          <div className="skill-box flex flex-col items-center justify-center bg-gray-100 p-6 rounded-lg shadow-md w-full">
            <i className="fab fa-html5 text-5xl text-red-600"></i>
            <h6 className="text-lg font-semibold mt-4">HTML</h6>
          </div>
          <div className="skill-box flex flex-col items-center justify-center bg-gray-100 p-6 rounded-lg shadow-md w-full">
            <i className="fab fa-css3-alt text-5xl text-blue-600"></i>
            <h6 className="text-lg font-semibold mt-4">CSS</h6>
          </div>
          <div className="skill-box flex flex-col items-center justify-center bg-gray-100 p-6 rounded-lg shadow-md w-full">
      <i className="fab fa-js text-5xl text-yellow-600"></i>
      <h6 className="text-lg font-semibold mt-4">JavaScript</h6>
    </div>
          <div className="skill-box flex flex-col items-center justify-center bg-gray-100 p-6 rounded-lg shadow-md w-full">
            <i className="fab fa-react text-5xl text-blue-400"></i>
            <h6 className="text-lg font-semibold mt-4">React JS</h6>
          </div>
          <div className="skill-box flex flex-col items-center justify-center bg-gray-100 p-6 rounded-lg shadow-md w-full">
            <i className="fas fa-database text-5xl text-green-500"></i>
            <h6 className="text-lg font-semibold mt-4">MongoDB</h6>
          </div>
          <div className="skill-box flex flex-col items-center justify-center bg-gray-100 p-6 rounded-lg shadow-md w-full">
            <i className="fa-brands fa-css3 text-5xl text-indigo-500"></i>
            <h6 className="text-lg font-semibold mt-4">Tailwind CSS</h6>
          </div>
          <div className="skill-box flex flex-col items-center justify-center bg-gray-100 p-6 rounded-lg shadow-md w-full">
            <i className="fab fa-node-js text-5xl text-green-600"></i>
            <h6 className="text-lg font-semibold mt-4">Express.js</h6>
          </div>
          <div className="skill-box flex flex-col items-center justify-center bg-gray-100 p-6 rounded-lg shadow-md w-full">
            <i className="fas fa-dice-d20 text-5xl text-yellow-500"></i>
            <h6 className="text-lg font-semibold mt-4">DaisyUI</h6>
          </div>
          <div className="skill-box flex flex-col items-center justify-center bg-gray-100 p-6 rounded-lg shadow-md w-full">
            <i className="fas fa-wind text-5xl text-purple-600"></i>
            <h6 className="text-lg font-semibold mt-4">Flowbite</h6>
          </div>
          
        </div>
      </div>
    </div>
  );
}

export default Skills;


// import React from 'react';

// function Skills() {
//   return (
//     <div className="containers">
//       <div className="section-heading">
//         <h1>
//           <span>MY SKILLS</span>
//         </h1>
//       </div>

//       <div className="content">
//         <div className="skills-grid">
//           <div className="skill-box html">
//             <i className="fab fa-html5"></i>
//             <h6>HTML</h6>
//           </div>
//           <div className="skill-box css">
//             <i className="fab fa-css3-alt"></i>
//             <h6>CSS</h6>
//           </div>
//           <div className="skill-box react">
//             <i className="fab fa-react"></i>
//             <h6>React JS</h6>
//           </div>
//           <div className="skill-box angular">
//             <i className="fab fa-mongodb"></i>
//             <h6>Mongo DB</h6>
//           </div>
//           <div className="skill-box ios">
//             <i className="fab fa-apple"></i>
//             <h6>IOS APP</h6>
//           </div>
//           <div className="skill-box app-dev">
//             <i className="fas fa-mobile-alt"></i>
//             <h6>APP DEV</h6>
//           </div>
//         </div>

//         <div className="image">
//           <img src="/images/faysal5.jpg" alt="mage" className="w-588 h-656" />
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Skills;
